import { DocumentNode, gql } from '@apollo/client';
import { LOCATION_FIELDS } from '../../components/location';
import { CreativeCreditFragment, DateRangeFragment, ReferenceFragment } from '../../list/fragments';

export const extractCreativeCreditsQuery: DocumentNode = gql`
    query extractCreativeCredits($text: String, $storageFileId: String) {
        extractCreativeCredits(text: $text, storageFileId: $storageFileId) {
            ...CreativeCredit
        }
    }
    ${CreativeCreditFragment}
    ${ReferenceFragment}
    ${DateRangeFragment}
    ${LOCATION_FIELDS}
`;
